import { Control, Controller } from "react-hook-form";

import { FormLabel } from "@ui/FormElements";
import { ICreateCompanyForm } from "../CompanyForm";
import { PlatformCompanySelect } from "../Selects";

export interface IPlatformCompanySaveOption {
  value: string | null;
  label: string;
  company: any;
}

interface IPlatformCompanyFormFieldProps {
  control: Control<ICreateCompanyForm>;
  onSave?: (value: IPlatformCompanySaveOption | null) => void;
}

export function PlatformCompanyFormField({ control, onSave }: IPlatformCompanyFormFieldProps) {
  return (
    <Controller
      control={control}
      name="platform"
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-1">
          <FormLabel htmlFor="type">Platform Company</FormLabel>
          <div className="w-full">
            <PlatformCompanySelect
              value={value}
              onChange={(option) => {
                onChange(option);
                onSave?.(option);
              }}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
}
